



































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import {
  ExpandedFacilityStatisticsPayload,
  ExpandedUnitStatisticsPayload,
  PriceOptimizerState, PriceOptimizerUnit
} from "@/models";
import moment from "moment";
import { Action, State } from "vuex-class";
import { StaticUnitData } from "@/models/StaticUnitData";

const namespace = "priceOptimizer";

@Component({
  name: "DateRangeStatistics"
})

export default class DateRangeStatistics extends Vue {
  // ===== Props ===== //
  @Prop({ default: 0 }) private readonly facilityId!: number;
  @Prop({ default: 0 }) private readonly unitTypeId!: number;
  // ===== Store ===== //
  @State("priceOptimizer") private readonly priceOptimizer!: PriceOptimizerState;
  @Action("getExpandedFacilityStatistics", { namespace })
    private getExpandedFacilityStatistics!: (payload: ExpandedFacilityStatisticsPayload) => void;
  @Action("getExpandedUnitStatistics", { namespace })
    private getExpandedUnitStatistics!: (payload: ExpandedUnitStatisticsPayload) => void;
  @Action("commitActiveUnitTypePanelTab", { namespace })
    private commitActiveUnitTypePanelTab!: (newVal: number) => void;
  // ===== Data ===== //
  private start_date = "";
  private end_date = "";

  // ===== Methods ===== //
  private async handleExpandedStatisticsRequest(range: string): Promise<void> {
    this.setDateRange(range);
    const dateRanges = {
      start_date: this.start_date,
      end_date: this.end_date
    };

    const facilityPayload: ExpandedFacilityStatisticsPayload = {
      ...dateRanges,
      facility_id: this.facilityId
    };
    await this.getExpandedFacilityStatistics(facilityPayload);

    const unitPayload: ExpandedUnitStatisticsPayload = {
      ...dateRanges,
      unit_type_id: this.unitTypeId
    };
    await this.getExpandedUnitStatistics(unitPayload);
  }
  private setDateRange(range: string): void {
    if (range === "-30 days") {
      this.start_date = moment.utc().subtract("30", "days").format();
      this.end_date = moment.utc().format();
      this.commitActiveUnitTypePanelTab(0);
    } else if (range === "-60 days") {
      this.start_date = moment.utc().subtract("60", "days").format();
      this.end_date = moment.utc().format();
      this.commitActiveUnitTypePanelTab(1);
    } else if (range === "-90 days") {
      this.start_date = moment.utc().subtract("90", "days").format();
      this.end_date = moment.utc().format();
      this.commitActiveUnitTypePanelTab(2);
    } else if (range === "lastYearSameMonth") {
      this.start_date = moment.utc().startOf("month").subtract("1", "year").format();
      this.end_date = moment.utc().endOf("month").subtract("1", "year").format();
      this.commitActiveUnitTypePanelTab(3);
    } else {
      this.start_date = moment.utc().startOf("month").subtract("1", "year")
        .add("1", "month").format();
      this.end_date = moment.utc().endOf("month").subtract("1", "year")
        .add("1", "month").format();
      this.commitActiveUnitTypePanelTab(4);
    }
  }
  private getCompPrice(primaryPrice: number, fallbackPrice: number): number {
    if (primaryPrice > 0) {
      return primaryPrice;
    }
    return fallbackPrice;
  }
  // ===== Computed ===== //
  get lastRateChange(): string {
    if (this.staticUnitData.lastRateChange === null) {
      return "N/A";
    }

    return `${this.staticUnitData.lastRateChange} day(s)`;
  }

  get staticUnitData(): StaticUnitData {
    const filteredUnit: PriceOptimizerUnit = this.priceOptimizer.filteredUnits
      .find(unit => unit.facility_unit_type_id === this.unitTypeId)!;

    return {
      competitorData: {
        avg: filteredUnit.comp_avg,
        high: filteredUnit.comp_high,
        low: filteredUnit.comp_low,
        comp_band_price_per_sq_ft: filteredUnit.comp_band_price_per_sq_ft,
        band_min_comp_price: filteredUnit.band_min_comp_price,
        band_avg_comp_price: filteredUnit.band_avg_comp_price,
        band_max_comp_price: filteredUnit.band_max_comp_price
      },
      features: {
        alarm: filteredUnit.is_alarm,
        climate: filteredUnit.is_climate,
        inside: filteredUnit.is_inside,
        mobile: filteredUnit.is_mobile,
        power: filteredUnit.is_power
      },
      lastRateChange: filteredUnit.days_since_last_rate_change,
      pricePerSqFt: filteredUnit.current_rate_per_sqft
    };
  }
}
